import type {FlagProps} from 'platform/components';
import {match} from 'ts-pattern';

import type {TrimOrderability} from '../../utils/getTrimOrderability';

export function getOrderabilityColorScheme(result: TrimOrderability): FlagProps['colorScheme'] {
  if (result.orderable) {
    return 'green';
  }
  return match(result.reasonKey)
    .with('previewNotOrderable', () => 'blue' as const)
    .with('soldOut', () => 'red' as const)
    .with('orderingStarts', () => 'orange' as const)
    .otherwise(() => 'neutral' as const);
}
